var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Table',{ref:"table",attrs:{"columns":_vm.columns,"data":_vm.list},scopedSlots:_vm._u([{key:"contact",fn:function(ref){
var row = ref.row;
return [_vm._v(" "+_vm._s(row.name)+" "),(row.contact)?_c('span',[_vm._v("("+_vm._s(row.contact)+")")]):_vm._e()]}},{key:"address",fn:function(ref){
var row = ref.row;
return [_vm._v(" "+_vm._s(row.address)+" "+_vm._s(row.number)+", "+_vm._s(row.house)+" "+_vm._s(row.zip)+" "+_vm._s(row.city)+" ")]}},{key:"type",fn:function(ref){
var row = ref.row;
return [(row.type)?_c('Tag',{attrs:{"color":"primary"}},[_vm._v(_vm._s(_vm.$t('name.address.type')))]):_vm._e()]}},{key:"created_at",fn:function(ref){
var row = ref.row;
return [_c('Time',{attrs:{"time":row.created_at * 1000,"type":"date"}})]}},{key:"action",fn:function(ref){
var row = ref.row;
return [_c('Poptip',{attrs:{"confirm":"","title":_vm.$t('name.delete_confirm')},on:{"on-ok":function($event){return _vm.onDelete(row)}}},[_c('a',[_vm._v(_vm._s(_vm.$t('name.delete')))])])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }